import React from "react"
import type { FC } from "react"

import { Box, Stack } from "@mui/material"
import type { SxProps, Theme } from "@mui/material"

import type { PageProps } from "./page.types"

type SxItem = Exclude<SxProps<Theme>, readonly unknown[]>

export const Page: FC<PageProps> = ({ children, fullHeight, ...rest }) => (
  <Stack
    {...rest}
    sx={[
      {
        p: 3,

        ...(fullHeight && {
          flex: 1,
          position: "relative",
        }),
      },

      ...((Array.isArray(rest.sx) ? rest.sx : [rest.sx]) as readonly SxItem[]),
    ]}
  >
    {fullHeight ? (
      <Box sx={{ flex: 1, position: "relative" }}>
        <Box
          sx={{
            bottom: 0,
            left: 0,
            position: "absolute",
            right: 0,
            top: 0,
          }}
        >
          {children}
        </Box>
      </Box>
    ) : (
      children
    )}
  </Stack>
)
